import { Component, OnInit } from '@angular/core';
import { Storage } from 'src/app/models/storage';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { SYSTEM } from '../../data/system';

@Component({
  selector: 'app-windows-container',
  templateUrl: './windows-container.component.html'
})
export class WindowsContainerComponent implements OnInit {

  subscription: Subscription;
  storage: Storage;

  readonly SYSTEM = SYSTEM;
  constructor(private storageService: StorageService) {
   }


   ngOnInit() {
    this.storage = this.storageService.storage;
    this.storageSubscription();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;
    });
  }

  changeSystem() {
    this.storageService.setSystemType(null);
  }

}
